import styled from 'styled-components';
import breakpoint from '../../../../utils/style-utils';

const PageLayout = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	row-gap: 12px;
	container: page-wrapper / inline-size;

	position: relative;
	z-index: 0;

	width: 100%;
	padding-bottom: 12px;

	${breakpoint.lg`
		row-gap: 20px;
		padding-bottom: 20px;
	`};
`;

export default PageLayout;
